(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfError', function() {
    return {
      restrict: 'E',
      require: '^mfErrorsContainer',
      link: (function(_this) {
        return function(scope, element, attrs) {
          var form;
          element.addClass('control-label');
          form = element.closest('mf-errors-container').attr('form');
          return scope.$watch(form + "." + attrs.input + ".$error." + attrs.error + " && !" + form + "." + attrs.input + ".$pristine", function(showError) {
            if (showError) {
              return element.show(100);
            } else {
              return element.hide(100);
            }
          });
        };
      })(this)
    };
  });


  /*
  <p class='animate-show control-label'
      ng-show="settingsForm.company_name.$error.required && !settingsForm.company_name.$pristine">
      Company Name is required
  </p>
   */

}).call(this);
